
(function () {
  function initMinimart(root) {
    if (!root || root.dataset.minimartInit === 'true') return;
    root.dataset.minimartInit = 'true';

    var PRODUCT_MAX = parseInt(root.getAttribute('data-product-slots'), 10) || 5;
    var DYNAMIC_MAX = PRODUCT_MAX; // grows by 3 every time it's reached
    var INITIAL = parseInt(root.getAttribute('data-initial-slots'), 10) || 3;
    var MIN_REQUIRED = Math.max(INITIAL, 3); // absolute floor — 3 minis minimum, no matter what the setting says

    var selected = [];
    var giftItem = null;
    var expanded = false;
    var giftAlreadyClaimed = false;

    var slotsContainer = root.querySelector('[data-minimart-slots]');
    var productSlots = Array.prototype.slice.call(root.querySelectorAll('.minimart-slot[data-slot-type="product"]'));
    var giftSlot = root.querySelector('.minimart-slot[data-slot-type="gift"]');
    var countEl = root.querySelector('[data-minimart-count]');
    var totalEl = root.querySelector('[data-minimart-total]');
    var submitBtn = root.querySelector('[data-minimart-submit]');
    var errorEl = root.querySelector('[data-minimart-error]');
    var expandBtn = root.querySelector('[data-minimart-expand]');
    var cards = root.querySelectorAll('[data-product-card]');

    var IDLE_LABEL = submitBtn ? submitBtn.textContent.trim() : 'Select your minis';
    var READY_LABEL = 'Add to Cart';

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    function scrollToGrid() {
      var target = document.getElementById('minimart');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function revealHiddenSlots() {
      if (expanded) return;
      expanded = true;
      root.querySelectorAll('.minimart-slot.is-hidden').forEach(function (slot) {
        slot.classList.remove('is-hidden');
      });
    }

    function wireSlotRemove(slot, index) {
      var remove = slot.querySelector('[data-slot-remove]');
      if (!remove) return;
      remove.addEventListener('click', function () {
        selected.splice(index, 1);
        showError('');
        render();
      });
    }

    function wireSlotBoxScroll(slot) {
      var box = slot.querySelector('[data-slot-box]');
      if (!box) return;
      box.addEventListener('click', function () {
        if (slot.classList.contains('is-filled')) return;
        scrollToGrid();
      });
    }

    function createSlotElement(index) {
      var div = document.createElement('div');
      div.className = 'minimart-slot flex-column gap-10';
      div.setAttribute('data-slot-index', index);
      div.setAttribute('data-slot-type', 'product');
      div.innerHTML =
        '<div class="minimart-slot-number secondary-font xxsm-text">' + (index + 1) + '</div>' +
        '<div class="minimart-slot-inner position-relative">' +
          '<button type="button" class="minimart-slot__box secondary-font xxsm-text uppercase" data-slot-box>' +
            '<span data-slot-label>Select Product</span>' +
          '</button>' +
          '<button type="button" class="minimart-remove secondary-font xsm-text primary" data-slot-remove aria-label="Remove">x</button>' +
        '</div>' +
        '<div class="minimart-slot__meta flex-column gap-5">' +
          '<div class="minimart-slot__variant micro-text" data-slot-variant>Scent</div>' +
          '<div class="minimart-slot__title xxsm-text secondary-font uppercase" data-slot-title>Product</div>' +
        '</div>';
      return div;
    }

    function growSlots(count) {
      var insertBefore = giftSlot || expandBtn || null;

      for (var n = 0; n < count; n++) {
        var index = productSlots.length;
        var slotEl = createSlotElement(index);

        if (insertBefore) {
          slotsContainer.insertBefore(slotEl, insertBefore);
        } else {
          slotsContainer.appendChild(slotEl);
        }

        wireSlotRemove(slotEl, index);
        wireSlotBoxScroll(slotEl);
        productSlots.push(slotEl);
      }

      DYNAMIC_MAX += count;
    }

    function checkGiftAlreadyInCart() {
      if (!giftSlot) return;
      var giftVariantId = root.getAttribute('data-gift-variant-id');
      if (!giftVariantId) return;

      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          giftAlreadyClaimed = cart.items.some(function (line) {
            return String(line.variant_id) === String(giftVariantId) &&
              line.properties && line.properties._minimart_gift === 'true';
          });
          render();
        })
        .catch(function () {
          giftAlreadyClaimed = false;
        });
    }

    function render() {
      // Reveal slots 4/5 (+ the gift slot) once the initial slots are filled
      if (selected.length >= INITIAL) revealHiddenSlots();

      productSlots.forEach(function (slot, i) {
        var item = selected[i];
        var box = slot.querySelector('[data-slot-box]');
        var title = slot.querySelector('[data-slot-title]');
        var variant = slot.querySelector('[data-slot-variant]');

        if (item) {
          slot.classList.add('is-filled');
          box.innerHTML = '<img src="' + item.image + '" alt="' + item.title + '">';
          title.textContent = item.title;
          variant.textContent = item.scent || 'Scent';
        } else {
          slot.classList.remove('is-filled');
          box.innerHTML = '<span data-slot-label>Select Product</span>';
          title.textContent = 'Product';
          variant.textContent = 'Scent';
        }
      });

      // Gift slot: not user-interactive. It's visible (dimmed, pointer-events
      // off) once the initial slots are filled, and fully unlocks the moment
      // the original 5 product slots are filled — auto-added, never clicked
      // or removed. Stays unlocked even as more slots get added beyond that.
      // Stays locked if the shopper already has one in their cart.
      if (giftSlot) {
        var unlocked = selected.length >= PRODUCT_MAX && !giftAlreadyClaimed;
        giftSlot.classList.toggle('is-locked', !unlocked);

        if (unlocked) {
          if (!giftItem) {
            giftItem = {
              id: root.getAttribute('data-gift-variant-id'),
              price: parseInt(root.getAttribute('data-gift-price'), 10) || 0
            };
          }
        } else {
          giftItem = null;
        }
      }

      var total = selected.reduce(function (sum, item) { return sum + item.price; }, 0);
      if (giftItem) total += giftItem.price;

      if (countEl) countEl.textContent = selected.length;
      if (totalEl) totalEl.textContent = money(total);
      if (submitBtn) {
        var isReady = selected.length >= MIN_REQUIRED;
        submitBtn.disabled = !isReady;
        submitBtn.textContent = isReady ? READY_LABEL : IDLE_LABEL;
      }

      cards.forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        var isIn = selected.some(function (item) { return String(item.id) === id; });
        card.classList.toggle('is-selected', isIn);
      });
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-add-to-minimart]');
      if (!btn) return;

      var idleLabel = btn.textContent.trim();
      var addedTimeout = null;

      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;

        if (selected.length >= DYNAMIC_MAX) {
          growSlots(3);
        }

        selected.push({
          id: card.getAttribute('data-variant-id'),
          title: card.getAttribute('data-title'),
          scent: card.getAttribute('data-scent'),
          price: parseInt(card.getAttribute('data-price'), 10) || 0,
          image: card.getAttribute('data-image')
        });

        showError('');
        render();

        btn.classList.add('is-added');
        btn.textContent = 'Added';
        if (addedTimeout) clearTimeout(addedTimeout);
        addedTimeout = setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = idleLabel;
        }, 900);
      });
    });

    productSlots.forEach(function (slot, i) {
      wireSlotRemove(slot, i);
      wireSlotBoxScroll(slot);
    });

  if (expandBtn) {
  expandBtn.addEventListener('click', function () {
    if (!expanded) {
      revealHiddenSlots();
    } else {
      growSlots(3);
      render();
    }
  });
}

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (selected.length < MIN_REQUIRED) return;

        submitBtn.disabled = true;

        var items = selected.map(function (item) {
          return {
            id: parseInt(item.id, 10),
            quantity: 1,
            properties: { _minimart_mini: 'true' }
          };
        });

        if (giftItem) {
          items.push({
            id: parseInt(giftItem.id, 10),
            quantity: 1,
            properties: { _minimart_gift: 'true' }
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Add to cart failed'); });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('minimart:added', { detail: { items: selected, gift: giftItem } }));

            if (giftItem) giftAlreadyClaimed = true;
            selected = [];
            giftItem = null;
            render();

            setTimeout(function () {
              if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
              if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
            }, 300);
          })
          .catch(function (err) {
            showError(err.message);
            render();
          });
      });
    }

    checkGiftAlreadyInCart();
    render();
  }

  document.querySelectorAll('[data-minimart]').forEach(initMinimart);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-minimart]').forEach(initMinimart);
  });
})();


(function () {
  if (window.__minimartCartWatcherInit) return;
  window.__minimartCartWatcherInit = true;

  var inFlightCheck = null;

  function getMinimartMin() {
    var root = document.querySelector('[data-minimart]');
    var initial = (root && parseInt(root.getAttribute('data-initial-slots'), 10)) || 3;
    return Math.max(initial, 3);
  }

  function getGiftThreshold() {
    var root = document.querySelector('[data-minimart]');
    return (root && parseInt(root.getAttribute('data-product-slots'), 10)) || 5;
  }

  function getGiftInfo() {
    var root = document.querySelector('[data-minimart]');
    if (!root || root.getAttribute('data-gift-enabled') !== 'true') return null;
    var variantId = root.getAttribute('data-gift-variant-id');
    if (!variantId) return null;
    return { variantId: variantId };
  }

  function addGiftLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { _minimart_gift: 'true' }
        }]
      })
    }).then(function (res) { return res.json(); });
  }

  function removeLines(items) {
    var updates = {};
    items.forEach(function (item) { updates[item.key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) { return res.json(); });
  }

  // Per UpCart's actual public API docs (docs.aftersell.com) — plain
  // global function, not namespaced under window.UpCart.
  function refreshCartDisplay() {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    } else {
      window.location.reload();
    }
  }

  // Returns a promise resolving to true if the cart was corrected, false
  // if it was already compliant. Concurrent callers share one in-flight
  // check instead of racing separate fetches against each other.
  function checkMinimartMinimum() {
    if (inFlightCheck) return inFlightCheck;

    var MINIMART_MIN = getMinimartMin();
    var GIFT_THRESHOLD = getGiftThreshold();

    inFlightCheck = fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var minis = cart.items.filter(function (item) {
          return item.properties && item.properties._minimart_mini === 'true';
        });
        var gift = cart.items.filter(function (item) {
          return item.properties && item.properties._minimart_gift === 'true';
        });
        var qty = minis.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        // Below the floor — strip minis AND gift. Only fires when there's
        // actually something mini-mart-related in the cart, so unrelated
        // carts (the overwhelming majority) never trigger a wasted call.
        // Deliberately NOT gated on qty > 0, so a cart that's dropped to
        // zero minis (all removed) but still holds a lingering gift also
        // gets corrected — the old qty > 0 guard silently skipped that case.
        if (qty < MINIMART_MIN && (minis.length || gift.length)) {
          return removeLines(minis.concat(gift)).then(function () {
            refreshCartDisplay();
            return true;
          });
        }

        // Above the floor but below the gift-unlock count — keep the
        // minis, strip just the gift, it's no longer earned.
        if (qty > 0 && qty < GIFT_THRESHOLD && gift.length) {
          return removeLines(gift).then(function () {
            refreshCartDisplay();
            return true;
          });
        }

        // Mirror case: qty is back up at the threshold but the gift isn't
        // in the cart — add it back automatically.
        if (qty >= GIFT_THRESHOLD && !gift.length) {
          var giftInfo = getGiftInfo();
          if (giftInfo) {
            return addGiftLine(giftInfo.variantId).then(function () {
              refreshCartDisplay();
              return true;
            });
          }
        }

        return false;
      })
      .catch(function () { return false; })
      .then(function (corrected) {
        inFlightCheck = null;
        return corrected;
      });

    return inFlightCheck;
  }

  function hookUpcartMinimartCheck() {
    checkMinimartMinimum();
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      window.upcartSubscribeCartUpdated(checkMinimartMinimum);
    }
    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(checkMinimartMinimum);
    }
  }
  setTimeout(hookUpcartMinimartCheck, 2000);

  // Trigger 2: any cart mutation made via fetch(), from any script.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var url = typeof target === 'string' ? target : (target && target.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)\.js/.test(url);

    var request = originalFetch.apply(this, arguments);
    if (isCartMutation) {
      request.then(function () {
        setTimeout(checkMinimartMinimum, 300);
      });
    }
    return request;
  };

  var OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var xhr = new OriginalXHR();
    var url = '';
    var originalOpen = xhr.open;
    xhr.open = function (method, requestUrl) {
      url = requestUrl;
      return originalOpen.apply(xhr, arguments);
    };
    xhr.addEventListener('load', function () {
      if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
        setTimeout(checkMinimartMinimum, 300);
      }
    });
    return xhr;
  }
  window.XMLHttpRequest = PatchedXHR;

  setInterval(checkMinimartMinimum, 5000);
  document.addEventListener('click', function (e) {
    var checkoutEl = e.target.closest('.upcart-checkout-button, a[href*="/checkout"]');
    if (!checkoutEl) return;
    if (checkoutEl.dataset.minimartVerified === 'true') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    checkMinimartMinimum().then(function (corrected) {
      if (corrected) return;

      checkoutEl.dataset.minimartVerified = 'true';
      checkoutEl.click();
      setTimeout(function () { checkoutEl.dataset.minimartVerified = 'false'; }, 3000);
    });
  }, true);
})();
(function () {
  var modal = document.querySelector('[data-minimart-quick-view-modal]');
  var content = modal && modal.querySelector('[data-minimart-quick-view-content]');
  if (!modal || !content || modal.dataset.quickViewInit === 'true') return;
  modal.dataset.quickViewInit = 'true';

  function closeQuickView() {
    modal.hidden = true;
    content.innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-minimart-quick-view-close]')) closeQuickView();
  });

  document.addEventListener('click', async function (e) {
    var trigger = e.target.closest('[data-minimart-quick-view]');
    if (!trigger) return;

    modal.hidden = false;
    content.innerHTML = '<div class="quick-view-loader"><div class="spinner"></div></div>';

    var res = await fetch('/products/' + trigger.dataset.productHandle + '?section_id=minimart-quickview');
    content.innerHTML = await res.text();

    var swiperEl = content.querySelector('.product-swiper');
    if (swiperEl && typeof Swiper !== 'undefined') {
      new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: { el: '.swiper-pagination', clickable: true }
      });
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add-to-minimart]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    var card = variantId && document.querySelector('[data-product-card][data-variant-id="' + variantId + '"]');
    var addBtn = card && card.querySelector('[data-add-to-minimart]');
    if (addBtn && !addBtn.hasAttribute('disabled')) {
      addBtn.click();
    }

    closeQuickView();
  });
})();